// import TrainingInstallApp from
// 'modules/training/components/InstallApp'
import {
  addRoundWorkoutSectionAction,
  canEditWorkoutUtil,
  createWorkoutSectionAction,
  getByIdWorkoutSectionSelector,
  getCurrentProfileSelect,
  getCurrentWorkoutSectionSelect,
  getCurrentWorkoutSelect,
  getMusclesCombinationStringWorkoutUtil,
  getOrderedMusclesWorkoutUtil,
  getShortDurationTimeUtil,
  isCircuitWorkoutSectionUtil,
  isInPlanWorkoutUtil,
  isTemporaryIdReduxUtil,
  startWorkoutAction,
  updateCurrentRoundIndexWorkoutExerciseAction,
  updateCurrentSetIndexWorkoutExerciseAction,
  updateCurrentWorkoutAction,
  updateCurrentWorkoutExerciseAction,
  updateCurrentWorkoutSectionAction,
  WORKOUT_KEY,
  WORKOUT_SECTION_KEY
} from '@gymaholic/packages'
import Button from 'components/Button'
import { DotsIcon } from 'components/Icon/icons/dots'
import { LoadingIcon } from 'components/Icon/icons/loading'
import { PlayIcon } from 'components/Icon/icons/play'
import { Image } from 'components/Image'
import { InstallAppForBetterWorkoutExperience } from 'components/InstallApp'
import NotFound from 'components/NotFound'
import Page from 'components/Page'
import { PageLoader } from 'components/Page/Page.Loader'
import PageShareButtons from 'components/Page/Page.ShareButtons.js'
import Text from 'components/Text'
import TextTitleCondensed from 'components/TextTitleCondensed'
import { View } from 'components/View'
import { ViewInApp } from 'components/ViewInApp.js'
// import ViewInApp from 'components/ViewInApp'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import openModalAction from 'modules/modal/actions/open'
import openAppSignInModalAction from 'modules/modal/actions/open-app-sign-in'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import getErrorReduxUtil from 'modules/redux/utils/get-error'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import getLocationRouterSelect from 'modules/router/selectors/get-location'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import getImageUrlWorkoutUtil from 'modules/training/models/workout/utils/get-image-url'
import getNotesWorkoutUtil from 'modules/training/models/workout/utils/get-notes'
import { TRAINING_DEEP_LINKS_ROUTES } from 'modules/training/modules/deep-links/constants'
import { navigateTrainingDeepLinkUtil } from 'modules/training/modules/deep-links/utils/navigate' // import {
// TRAINING_DEEP_LINKS_ROUTES
// } from
// 'modules/training/modules/deep-links/constants' import
// navigateTrainingDeepLinkUtil from
// 'modules/training/modules/deep-links/utils/navigate'
import setCurrentWorkoutSectionAction from 'modules/training/modules/training-start-workout/actions/set-current-workout-section'
import { getStartWorkoutSelector } from 'modules/training/modules/training-start-workout/selectors'
import { loadBySharedKeyWorkoutAction } from 'modules/workout/redux/actions/load-by-share-key'
import ChipButton from 'pages/Workout/components/ChipButton'
import FloatingStartWorkoutButton from 'pages/Workout/components/FloatingStartWorkoutButton'
import Round from 'pages/Workout/components/Round'
import SetList from 'pages/Workout/components/SetList'
import SetListRounds from 'pages/Workout/components/SetListRounds'
import WorkoutSection from 'pages/Workout/components/WorkoutSection'
import { WORKOUT_SET_DATA_MODAL_TYPES } from 'modules/workout/redux/constants'
import {
  getByIdWorkoutSelector,
  getCombinedSetDataSelector,
  getRoundsSetDataSelector
} from 'modules/workout/redux/selectors'
import {
  getWidthViewportSelect,
  isMobileScreenViewportSelect
} from 'modules/viewport/selectors'
import {
  logUtil,
  toSlugStringUtil
} from 'packages/src'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import MediaImage from 'containers/MediaImage'
import getNameReduxUtil from 'modules/redux/utils/get-name'
import pushRouterAction from 'modules/router/actions/push'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { FixedSizeList } from 'react-window'
import PowerHybridVideo from 'components/PowerHybridVideo/index.js'
import isPowerHybridChallengeWorkoutUtil from 'modules/workout/redux/utils/is-power-hybrid-challenge/index.js'
import { getLocationQueryParamsRouterSelect } from 'modules/router/selectors/index.js'
import getEquipmentStrWorkoutUtil from 'modules/workout/utils/get-equipment-str/index.js'
import { ProfilesWhoStartedThisWorkout } from 'pages/Workout/components/ProfilesWhoStartedThisWorkout/index.js'
import TrendingIconOverlay from 'components/TrendingIconOverlay/index.js'
import isTrendingModelUtil from 'models/utils/is-trending/index.js'
import isDeeplyLoadedReduxUtil from '@gymaholic/packages/src/modules/redux/utils/is-deeply-loaded/index.js'
import WorkoutNotes from 'pages/Workout/components/Workout/components/Notes/index.js'
import WorkoutName from 'pages/Workout/components/Workout/components/Name/index.js'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'
import { getPremiumYearlyUrlRouteUtil } from 'modules/training/modules/subscription/utils/get-premium-yearly-url/index.js'
import { WorkoutFloatingGetPremiumButton } from 'pages/Workout/components/FloatingGetPremiumButton/index.js'
import { WorkoutPlanRow } from 'pages/Workout/components/PlanRow/index.js'
import goBackRouterAction from 'modules/router/actions/go-back/index.js'
import openErrorBannerAction from 'modules/banner/actions/open-error/index.js'
import { getPaddingHorizontalWorkoutSelect } from 'pages/Workout/redux/selectors/get-padding-horizontal/index.js'
import { isLoggedInTrainingUserSelect } from 'modules/training/modules/training-users/selectors/is-logged-in/index.js'
import scrollToTopDomUtil from 'client/utils/dom/scroll-to-top/index.js'
import runAfterDelayPromisifiedPerformanceUtil from 'modules/performance/run-after-delay-promisified/index.js'
import { getListWidthAppSelect } from 'modules/app/selectors/getListWidth/index.js'
import loadByIdWorkoutAction from 'modules/workout/redux/actions/load-by-id/index.js'

const ANALYTIC_EVENT = {
  VIEW_WORKOUT_IN_APP: 'VIEW_WORKOUT_IN_APP',
  START_WORKOUT: 'START_WORKOUT',
  START_WORKOUT_LOGIN: 'START_WORKOUT_LOGIN',
  START_WORKOUT_IN_PLAN_PREMIUM: 'START_WORKOUT_IN_PLAN_PREMIUM',
  START_WORKOUT_NEEDS_TO_START_PLAN: 'START_WORKOUT_NEEDS_TO_START_PLAN',
  COMPLETE_WORKOUT: 'COMPLETE_WORKOUT',
  COMPLETE_WORKOUT_LOGIN: 'COMPLETE_WORKOUT_LOGIN'
}

const messages = defineMessages({
  valueAndMorePlus: {
    id: 'Workout.valueAndMorePlus',
    defaultMessage: '{value} +'
  },
  startWorkout: {
    id: 'Workout.startWorkout',
    defaultMessage: 'Start Workout'
  },
  viewWorkoutInApp: {
    id: 'Workout.viewWorkoutInApp',
    defaultMessage: 'View workout in app'
  },
  addExercise: {
    id: 'Workout.addExercise',
    defaultMessage: 'Add Exercise'
  },
  youNeedToStartThisPlan: {
    id: 'Workout.youNeedToStartThisPlan',
    defaultMessage: 'You need to start this plan to edit or start a workout in this plan.'
  },
  ifYouHaveTheAppInstalled: {
    id: 'Workout.ifYouHaveTheAppInstalled',
    defaultMessage: 'If you already have the app installed, you can view this workout in the app.'
  }
})

const getPageValueProp = (instance) => {
  if (!instance) {
    return {}
  }
  return {
    title: getNameReduxUtil(instance),
    description: getNotesWorkoutUtil(instance),
    img: getImageUrlWorkoutUtil(instance)
  }
}

const ANALYTICS_EVENT_PREFIX = 'WORKOUT_PAGE'

/**
 * @param id
 * @param shareKey
 * @param match
 * @returns {Element}
 * @constructor
 */
export default function Workout ({
  id,
  shareKey,
  match
}) {
  const isMobileScreen = useSelector(isMobileScreenViewportSelect)
  const profile = useSelector(getCurrentProfileSelect)
  const dispatch = useDispatch()
  const intl = useIntl()
  const workout = useSelector(getByIdWorkoutSelector(id))
  const workoutSections = getValueReduxUtil(workout, WORKOUT_KEY.WORKOUT_SECTIONS)
  const startWorkout = useSelector(getStartWorkoutSelector())
  const workoutSectionId = getIdReduxUtil(workoutSections && workoutSections[startWorkout.currentWorkoutSectionIndex])
  const workoutSection = useSelector(getByIdWorkoutSectionSelector(workoutSectionId))
  const workoutExercises = getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.WORKOUT_EXERCISES)
  const combinedSetData = useSelector(getCombinedSetDataSelector(workoutExercises))
  const roundsSetData = useSelector(getRoundsSetDataSelector(workoutExercises))
  const [selectedRoundIndex, setSelectedRoundIndex] = React.useState(0)
  const [isCircuit, setIsCircuit] = React.useState(null)
  const currentWorkout = useSelector(getCurrentWorkoutSelect)
  const currentWorkoutSection = useSelector(getCurrentWorkoutSectionSelect)
  const workoutSectionsListRef = React.useRef()
  const [loadingStartWorkout, setIsLoadingStartWorkout] = React.useState(false)
  const [loadingWorkoutDone, setLoadingWorkoutDone] = React.useState(false)
  const name = getNameReduxUtil(workout)
  const queryParams = useSelector(getLocationQueryParamsRouterSelect)
  // If the URL contains /plans/, it's a plan workout, otherwise it's a recommended workout
  const location = useSelector(getLocationRouterSelect)
  const isRecommended = !location?.pathname?.includes('/plans/')
  const hasPremium = useSelector(hasPremiumUserSelect)
  const canEdit = canEditWorkoutUtil(currentWorkout, profile)
  const isInPlan = isInPlanWorkoutUtil(currentWorkout)
  const needsPremium = isInPlan && !canEdit && !hasPremium
  const paddingHorizontal = useSelector(getPaddingHorizontalWorkoutSelect)
  const isLoggedIn = useSelector(isLoggedInTrainingUserSelect)

  const debugProps = {
    id,
    workout,
    currentWorkout,
    queryParams,
    isRecommended,
    workoutSections
  }
  logUtil('Workout').debug('debugProps=', debugProps)

  const slug = toSlugStringUtil(name)
  const pageValueProp = getPageValueProp(currentWorkout)
  const viewportWidth = useSelector(getWidthViewportSelect)
  const maxWidthDesktop = useSelector(getListWidthAppSelect)
  const [isAboutVisible, setIsAboutVisible] = React.useState(false)

  const load = () => {
    if (
      workout &&
      isRecommended &&
      !!workoutSections?.length
    ) {
      logUtil('Workout#load').debug('[noop] already loaded')
      return
    }

    if (isDeeplyLoadedReduxUtil(workout)) {
      logUtil('Workout#load').debug('[noop] deeply loaded')
      return
    }

    if (shareKey) {
      logUtil('Workout#load').debug('call loadBySharedKeyWorkoutAction')
      dispatch(loadBySharedKeyWorkoutAction({ shareKey }))
      return
    }

    dispatch(loadByIdWorkoutAction({ id }))
  }

  const handleScroll = async () => {
    await runAfterDelayPromisifiedPerformanceUtil({
      delay: 0
    })
    scrollToTopDomUtil(true)
  }

  const handleMount = () => {
    load()
    handleScroll()
    dispatch(setCurrentWorkoutSectionAction(0))
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  React.useEffect(() => {
    if (workout) {
      dispatch(updateCurrentWorkoutAction(workout))
    }
  }, [workout])

  const navigateToStartWorkout = () => {
    const currentWorkoutId = Number(getIdReduxUtil(currentWorkout))
    const newWorkoutSectionId = getIdReduxUtil(currentWorkoutSection)
    const newWorkoutExerciseId = getIdReduxUtil(currentWorkoutSection.data.workoutExercises[0])
    const path = interpolateRouteUtil(
      ROUTE_PATH.START_WORKOUT,
      {
        id: currentWorkoutId,
        slug
      }
    )
    let queryParams = `?workoutSectionId=${newWorkoutSectionId}&workoutExerciseId=${newWorkoutExerciseId}&setIndex=0`

    if (match.params.name !== undefined) {
      queryParams = queryParams + '&isCreator=true'
    }

    setIsLoadingStartWorkout(false)
    dispatch(
      pushRouterAction({
        pathname: path,
        search: queryParams
      })
    )
  }

  const navigateToCompleteWorkout = () => {
    const currentWorkoutId = Number(getIdReduxUtil(currentWorkout))
    setLoadingWorkoutDone(false)
    const path = interpolateRouteUtil(
      ROUTE_PATH.WORKOUT_ACHIEVEMENTS,
      {
        id: currentWorkoutId,
        slug
      }
    )

    let queryParams = ''
    if (match.params.name !== undefined) {
      queryParams = queryParams + '&isCreator=true'
    }

    dispatch(
      pushRouterAction({
        pathname: path,
        search: queryParams
      })
    )
  }

  React.useEffect(() => {
    const currentWorkoutId = Number(getIdReduxUtil(currentWorkout))
    const canEdit = canEditWorkoutUtil(currentWorkout, profile)
    const hasCopiedWorkout = Number(id) !== currentWorkoutId
    const isSavedWorkout = (
      currentWorkoutId != null &&
      !isTemporaryIdReduxUtil(currentWorkoutId) > 0
    )

    // Recommended workout
    if (
      canEdit &&
      hasCopiedWorkout &&
      isSavedWorkout &&
      loadingStartWorkout
    ) {
      navigateToStartWorkout()
      return
    }

    // Own workout
    if (
      canEdit &&
      isSavedWorkout &&
      loadingStartWorkout
    ) {
      navigateToStartWorkout()
      return
    }

    if (
      canEdit &&
      hasCopiedWorkout &&
      isSavedWorkout &&
      loadingWorkoutDone
    ) {
      navigateToCompleteWorkout()
    }
  }, [
    currentWorkout
  ])

  React.useEffect(() => {
    if (workoutSection) {
      const isCircuit = isCircuitWorkoutSectionUtil(workoutSection)
      setIsCircuit(isCircuit)
    }
  }, [workoutSection])

  React.useEffect(() => {
    workoutSectionsListRef.current?.scrollToItem(startWorkout.currentWorkoutSectionIndex)
  }, [
    startWorkout.currentWorkoutSectionIndex,
    workoutSections
  ])

  const handleClickSetValue = (workoutExercise) => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(updateCurrentWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(workoutExercise.originalSetIndexInsideWorkoutExerciseObj))
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_VALUE,
        setData: workoutExercise.setData
      })
    )
  }

  const handleClickSetType = (workoutExercise) => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(updateCurrentWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(workoutExercise.originalSetIndexInsideWorkoutExerciseObj))
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_TYPE,
        setData: workoutExercise.setData
      })
    )
  }

  const handleClickWeight = (workoutExercise) => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(updateCurrentWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(workoutExercise.originalSetIndexInsideWorkoutExerciseObj))
    dispatch(
      openModalAction(MODAL_ID.WORKOUT_SET_INFO, {
        modalType: WORKOUT_SET_DATA_MODAL_TYPES.SET_WEIGHT,
        setData: workoutExercise.setData
      })
    )
  }

  const renderSetRowList = () => {
    if (combinedSetData.length > 0) {
      return (
        <SetList
          items={combinedSetData}
          handleClickSetValue={handleClickSetValue}
          handleClickSetType={handleClickSetType}
          handleClickWeight={handleClickWeight}
          isWorkoutScreen
          workoutSectionId={workoutSectionId}
          needsPremium={needsPremium}
        />
      )
    }
  }

  const renderRoundsSetRowList = () => {
    if (
      roundsSetData.length >
      0 &&
      roundsSetData[selectedRoundIndex] &&
      roundsSetData[selectedRoundIndex].combinedSetData
    ) {
      return (
        <SetListRounds
          items={roundsSetData}
          handleClickSetValue={handleClickSetValue}
          handleClickSetType={handleClickSetType}
          handleClickWeight={handleClickWeight}
          selectedRoundIndex={selectedRoundIndex}
          isWorkoutScreen
          needsPremium={needsPremium}
        />
      )
    }
  }

  if (
    !workout ||
    isLoadingReduxUtil(workout)
  ) {
    return (
      <PageLoader />
    )
  }

  if (getErrorReduxUtil(workout)) {
    return <NotFound />
  }

  const getStartWorkoutLink = () => {
    if (!workoutExercises) {
      return
    }

    return `${interpolateRouteUtil(ROUTE_PATH.START_WORKOUT, {
      id: id,
      slug: toSlugStringUtil(getNameReduxUtil(workout))
    })}?workoutSectionId=${getIdReduxUtil(workoutSection)}&workoutExerciseId=${getIdReduxUtil(
      workoutExercises[0])}&setIndex=0`
  }

  const getEquipmentStr = () => {
    return getEquipmentStrWorkoutUtil({
      intl,
      workout
    })
  }

  const duration = getValueReduxUtil(workout, WORKOUT_KEY.DURATION)
  const musclesStr = getMusclesCombinationStringWorkoutUtil(
    getOrderedMusclesWorkoutUtil(workout),
    intl
  )

  const workoutDetails = [
    getShortDurationTimeUtil(duration),
    getEquipmentStr(),
    musclesStr
  ]

  const calories = (
    getValueReduxUtil(workout, WORKOUT_KEY.ESTIMATED_CALORIES) ||
    getValueReduxUtil(workout, WORKOUT_KEY.CALORIES)
  )

  if (calories) {
    workoutDetails.push(
      `${calories} kcal`
    )
  }

  const handleClickWorkoutSection = (index) => {
    if (index === startWorkout.currentWorkoutSectionIndex) {
      return
    }

    const workoutSection = workoutSections[index]
    const workoutSectionId = getIdReduxUtil(workoutSection)

    dispatch(updateCurrentWorkoutSectionAction(workoutSectionId))
    dispatch(setCurrentWorkoutSectionAction(index))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(0))
    dispatch(updateCurrentRoundIndexWorkoutExerciseAction(0))
  }

  const isRoundSelected = (index) => {
    return index === selectedRoundIndex
  }

  const handleClickRound = (index) => {
    if (index === selectedRoundIndex) {
      return
    }

    setSelectedRoundIndex(index)
  }

  const handleClickCreateRound = () => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(addRoundWorkoutSectionAction())
  }

  const renderRounds = () => {
    if (!isCircuit) {
      return
    }

    if (!roundsSetData) {
      return
    }

    return (
      <View
        m={isMobileScreen ? 'unset' : '0 auto'}
        mt
        w={isMobileScreen ? 'unset' : `${maxWidthDesktop}px`}
      >
        <FixedSizeList
          className='no-scrollbars'
          height={40}
          itemCount={roundsSetData.length + 1}
          itemSize={108}
          layout='horizontal'
          width={isMobileScreen ? viewportWidth : maxWidthDesktop}
        >
          {({
            index,
            style
          }) => (
            <Round
              index={index}
              style={style}
              handleClickCreateRound={needsPremium ? null : handleClickCreateRound}
              handleClickRound={handleClickRound}
              isSelected={isRoundSelected(index)}
              roundsSetData={roundsSetData}
            />
          )}
        </FixedSizeList>
      </View>
    )
  }

  const startWorkoutLinkTo = getStartWorkoutLink()

  const handlePressStartWorkout = () => {
    if (isInPlan && !canEdit) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.START_WORKOUT_NEEDS_TO_START_PLAN)
      dispatch(goBackRouterAction())
      dispatch(openErrorBannerAction({ message: formatMessageIntlUtil(intl, messages.youNeedToStartThisPlan) }))
      return
    }

    if (needsPremium) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.START_WORKOUT_IN_PLAN_PREMIUM)
      const url = getPremiumYearlyUrlRouteUtil()
      dispatch(pushRouterAction(url))
      return
    }

    if (!isLoggedIn) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.START_WORKOUT_LOGIN)
      dispatch(openAppSignInModalAction())
      return
    }

    logEventAnalyticsUtil(ANALYTIC_EVENT.START_WORKOUT)

    dispatch(
      startWorkoutAction(() => {
      })
    )

    setIsLoadingStartWorkout(true)
  }

  const handlePressViewWorkoutInApp = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_WORKOUT_IN_APP)
    navigateTrainingDeepLinkUtil(
      TRAINING_DEEP_LINKS_ROUTES.WORKOUT_BY_ID,
      { id }
    )
  }

  // const handlePressCompleteWorkout = async () => {
  //   if (!isLoggedIn) {
  //     logEventAnalyticsUtil({
  //  ANALYTIC_EVENT.COMPLETE_WORKOUT_LOGIN)
  //     dispatch(openAppSignInModalAction())
  //     return
  //   }
  //
  //   logEventAnalyticsUtil(ANALYTIC_EVENT.COMPLETE_WORKOUT)
  //   const parentId = getParentIdWorkoutUtil(currentWorkout)
  //
  //   dispatch(logWorkoutAction({ id }))
  //   if (!parentId) {
  //     setLoadingWorkoutDone(true)
  //   } else {
  //     navigateToCompleteWorkout()
  //   }
  // }

  const handleClickCreateWorkoutSection = () => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(createWorkoutSectionAction())
  }

  const handleClickMenu = (event) => {
    event.stopPropagation()
    dispatch(updateCurrentWorkoutSectionAction(id))
    dispatch(openModalAction(
      MODAL_ID.WORKOUT_SECTION_EDIT,
      {
        workoutSection,
        isCircuit
      }
    ))
  }

  const handleClickAddExercise = () => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(
      pushRouterAction(
        { pathname: ROUTE_PATH.ADD_EXERCISES_LIST },
        {
          originMatch: match,
          workoutSectionId
        }
      )
    )
  }

  const canonicalUrl = location.origin + interpolateRouteUtil(
    ROUTE_PATH.WORKOUT_BY_ID_SLUG,
    {
      id: id,
      slug
    }
  )

  const isTrending = !!isTrendingModelUtil(workout)
  const handleClickName = () => setIsAboutVisible(!isAboutVisible)

  const planId = getValueReduxUtil(workout, WORKOUT_KEY.PLAN_ID)

  return (
    <Page
      style={{
        padding: 0,
        paddingBottom: '100px'
      }}
      title={name}
      value={pageValueProp}
      url={canonicalUrl}
    >

      <View
        m={isMobileScreen
          ? 'unset'
          : '0 auto'}
        w={isMobileScreen
          ? 'unset'
          : `${maxWidthDesktop}px`}
      >
        <View
          px={isMobileScreen ? paddingHorizontal : 0}
        >
          <Button
            onClick={handlePressStartWorkout}
            isFullWidth
            style={{
              height: 'unset',
              maxWidth: '100vw'
            }}
            isDisabled={loadingStartWorkout}
          >
            <View
              ac
              mt={2}
              w
              style={{ position: 'relative' }}
            >
              {!!isTrending && <TrendingIconOverlay />}

              <MediaImage
                id={getValueReduxUtil(workout, WORKOUT_KEY.MEDIA_ID)}
                style={{
                  height: '140px',
                  borderRadius: '6px',
                  objectFit: 'cover',
                  width: '100%'
                }}
                aspectRatio={Image.ASPECT_RATIO.WIDE_SMALL}
                alt={getNameReduxUtil(workout)}
              />

              {
                !!startWorkoutLinkTo && (
                  <View
                    centered
                    style={{
                      height: '140px',
                      width: '100%',
                      background: '#0000004d',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      borderRadius: '6px'
                    }}
                  >
                    <View
                      row
                      ac
                      style={{
                        position: 'absolute',
                        top: '40px',
                        left: '33%'
                      }}
                    >
                      <View
                        style={{
                          width: '60px',
                          height: '60px',
                          maxWidth: 'unset',
                          background: '#ffffff',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        {loadingStartWorkout
                          ? (
                            <LoadingIcon
                              stroke='black'
                              style={{
                                width: '30px',
                                height: '30px'
                              }}
                            />
                            )
                          : (
                            <PlayIcon
                              fill='#000000'
                              style={{
                                width: '27.36px',
                                height: '27.36px',
                                marginLeft: '7px'
                              }}
                            />
                            )}
                      </View>
                      <TextTitleCondensed
                        c='#ffffff'
                        fw='700'
                        fs='26px'
                        ml='16px'
                        lh='24px'
                        style={{
                          textAlign: 'left',
                          width: '95px'
                        }}
                      >
                        {formatMessageIntlUtil(intl, messages.startWorkout)}
                      </TextTitleCondensed>
                    </View>
                  </View>
                )
              }
            </View>
          </Button>

          <View
            row
            mt='16px'
            style={{ flexWrap: 'wrap' }}
          >
            {workoutDetails.map((feature, index) => (
              <View
                key={index}
                bgc='#F6F6F6'
                mr='0.5rem'
                py='0.295em'
                px='6px'
                mb='1em'
                style={{ borderRadius: '4px' }}
              >
                <Text
                  c='#151D21'
                  fs='0.725em'
                  fw='590'
                >
                  {feature}
                </Text>
              </View>
            ))}
          </View>

          <WorkoutName
            id={id}
            isAboutVisible={isAboutVisible}
            onClickName={handleClickName}
          />
          {isAboutVisible && <WorkoutNotes id={id} />}

          {
            !!isPowerHybridChallengeWorkoutUtil(workout) && (
              <PowerHybridVideo
                analyticsEventPrefix={ANALYTICS_EVENT_PREFIX}
              />
            )
          }

          <ProfilesWhoStartedThisWorkout />
          {
            !!planId && (
              <WorkoutPlanRow
                planId={planId}
                isRecommended={!canEdit}
              />
            )
          }

          {
            !needsPremium && isLoggedIn && (
              <>
                <InstallAppForBetterWorkoutExperience />
                <ViewInApp
                  onClick={handlePressViewWorkoutInApp}
                  text={formatMessageIntlUtil(intl, messages.viewWorkoutInApp)}
                  installedText={formatMessageIntlUtil(intl, messages.ifYouHaveTheAppInstalled)}
                />
              </>
            )
          }

        </View>
      </View>

      {
        workoutSections && (
          <View
            m={isMobileScreen ? 'unset' : '0 auto'}
            pt
            w={isMobileScreen ? 'unset' : `${maxWidthDesktop}px`}
          >
            <FixedSizeList
              className='no-scrollbars'
              height={40}
              itemCount={workoutSections.length + 1}
              itemSize={113}
              layout='horizontal'
              width={isMobileScreen ? viewportWidth : maxWidthDesktop}
              ref={workoutSectionsListRef}
            >
              {({
                index,
                style
              }) => {
                return (
                  <WorkoutSection
                    style={style}
                    id={getIdReduxUtil(workoutSections[index])}
                    index={index}
                    handleClickWorkoutSection={handleClickWorkoutSection}
                    isCircuit={isCircuit}
                    handleClickCreateWorkoutSection={
                      needsPremium
                        ? null
                        : handleClickCreateWorkoutSection
                    }
                    workoutSections={workoutSections}
                  />
                )
              }}
            </FixedSizeList>
          </View>
        )
      }

      {renderRounds()}
      <View
        px={paddingHorizontal}
        row
        w={isMobileScreen ? 'unset' : `${maxWidthDesktop}px`}
        m={isMobileScreen ? 'unset' : '0 auto'}
        mt='12px'
        ac
        style={{ justifyContent: 'space-between' }}
      >
        <Text
          fs='1.3em'
          fw='500'
        >
          {getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.NAME)}
        </Text>

        {
          !needsPremium && (
            <Button
              onClick={handleClickMenu}
              style={{ height: 'unset' }}
            >
              <DotsIcon
                style={{
                  width: '2em',
                  marginTop: '2px'
                }}
              />
            </Button>
          )
        }
      </View>

      {
        isCircuit
          ? renderRoundsSetRowList()
          : renderSetRowList()
      }

      {
        !needsPremium && (
          <>
            <View
              mt={2}
              centered
            >
              <ChipButton
                onClick={handleClickAddExercise}
                text={formatMessageIntlUtil(intl, messages.addExercise)}
              />
            </View>

            <PageShareButtons
              title={pageValueProp.title}
              url={match.pathname}
              img={pageValueProp.img}
              style={{
                alignItems: 'center'
              }}
            />
          </>
        )
      }

      {
        needsPremium
          ? <WorkoutFloatingGetPremiumButton />
          : (
            <FloatingStartWorkoutButton
              onClick={handlePressStartWorkout}
              isLoading={loadingStartWorkout}
              isDisabled={loadingStartWorkout}
            />
            )
      }
    </Page>
  )
}
